import { defineMessages } from 'react-intl';

export const ageGenderMessages = defineMessages({
    title: {
        id: 'ageGenderMessages.title',
        defaultMessage: 'Date of Birth and Gender',
        description: 'Title shown on the age and gender entry screen',
    },
    heading: {
        id: 'ageGenderMessages.heading',
        defaultMessage: 'Add your date of birth and your gender',
        description: 'Instruction to add date of birth and gender',
    },
    subHeading: {
        id: 'ageGenderMessages.subHeading',
        defaultMessage:
            'We use this information to personalize your experience in the product.',
        description: 'Collected information usage details',
    },
    dobInputLabel: {
        id: 'ageGenderMessages.dobInputLabel',
        defaultMessage: 'Date of Birth (Required)',
        description: 'Date of birth input label',
    },
    dobInputError: {
        id: 'ageGenderMessages.dobInputError',
        defaultMessage: 'Error: Date of Birth is required',
        description:
            'Submission error when the required Date of birth input has been left empty',
    },
    genderSelectLabel: {
        id: 'ageGenderMessages.genderSelectLabel',
        defaultMessage: 'Gender',
        description: 'Gender dropdown select input label',
    },
    notAvailableDialogTitle: {
        id: 'ageGenderMessages.notAvailableDialogTitle',
        defaultMessage: 'You do not have access to Calm Health',
        description: 'Title for the not available dialog',
    },
    notAvailableDialogCopy: {
        id: 'ageGenderMessages.notAvailableDialogCopy',
        defaultMessage:
            'Based on the information provided, you do not currently have access to Calm Health. If you believe this is an error, please contact your benefits administrator',
        description: 'Copy for the not available dialog',
    },
});
